export enum CategoryKeys {
  HOME = 'home',
  // stocks
  STOCKS_HOME = 'stocks_home',
  STOCKS_DIVIDEND = 'stocks_dividend',
  STOCKS_DETAIL = 'stocks_detail',
  STOCKS_CATEGORY = 'stocks_category',
  STOCKS_RESULTS = 'stocks_results',
  HOME_V2 = 'home_v2',

  // mutual funds
  MF_HOME = 'mutual_fund_home',
  MF_FUND_DETAIL = 'mutual_fund_detail',
  MF_CATEGORY = 'mutual_fund_category',
  MF_AMC = 'mutual_fund_amc',

  // articles
  ARTICLES_HOME = 'articles_home',
  ARTICLES_DETAIL = 'articles_detail',
  ARTICLES_CATEGORY_DETAIL = 'articles_category_detail',

  // indices
  INDICES_HOME = 'indices_home',
  INDICES_DETAIL = 'indices_detail',

  //fno
  FNO_HOME = 'fno_home',
  FUTURES_DETAIL_PAGE = 'fUTURES_detail',
  OPTIONS_DETAIL_PAGE = 'options_detail',

  // calculators
  CALCULATORS_HOME = 'calculators_home',
  CALCULATORS_PAGE = 'calculators_page',

  CALCULATORS_BROKERAGE = 'calculators_brokerage',
  CALCULATORS_HRA = 'calculators_hra',
  CALCULATORS_NPS = 'calculators_nps',
  CALCULATORS_SALARY = 'calculators_salary',
  CALCULATORS_TERM_INSURANCE = 'calculators_term_insurance',
  CALCULATORS_INCOME_TAX = 'calculators_income_tax',
  CALCULATORS_DIRECT_REGULAR_MF = 'calculators_direct_regular_mutual_fund',

  // IND Learn
  LEARN_HOME = 'learn_home',
  LEARN_COURSE = 'learn_course',
  LEARN_CHAPTER = 'learn_chapter',

  // Features
  FEATURES_HOME = 'features_home',
  FEATURES_DETAIL = 'features_details',

  // IPO
  IPO_HOME = 'ipo_home',
  IPO_DETAIL = 'ipo_detail',

  // US STOCKS
  US_STOCKS_HOME = 'us_stocks_home',
  US_STOCKS_DETAIL = 'us_stocks_detail',
  US_STOCKS_CATEGORY = 'us_stocks_category',
  US_STOCKS_DIVIDEND = 'us_stocks_dividend',
  US_STOCKS_TECHNICAL = 'us_stocks_technical',
}

export const categoryRoutes = {
  [CategoryKeys.HOME]: '/',
  [CategoryKeys.HOME_V2]: '/',
  // stocks
  [CategoryKeys.STOCKS_DIVIDEND]: '/stocks/dividend/[slug]',
  [CategoryKeys.STOCKS_DETAIL]: '/stocks/[stockSlug]',
  [CategoryKeys.STOCKS_CATEGORY]: '/stocks/category/[categorySlug]',
  [CategoryKeys.STOCKS_HOME]: '/stocks',
  [CategoryKeys.STOCKS_RESULTS]: '/stocks/results/[slug]',

  // mutual funds
  [CategoryKeys.MF_HOME]: '/mutual-funds',
  [CategoryKeys.MF_FUND_DETAIL]: '/mutual-funds/fund/[slug]/[scheme_id]',
  [CategoryKeys.MF_CATEGORY]: '/mutual-funds/[mf_category]',
  [CategoryKeys.MF_AMC]: '/mutual-funds/amc/[slug]',

  // articles
  [CategoryKeys.ARTICLES_HOME]: '/blog',
  [CategoryKeys.ARTICLES_DETAIL]: '/blog/[slug]',
  [CategoryKeys.ARTICLES_CATEGORY_DETAIL]: '/blog/[slug]/[article_slug]',

  // indices
  [CategoryKeys.INDICES_HOME]: '/indices',
  [CategoryKeys.INDICES_DETAIL]: '/indices/[stockSlug]',

  //fno
  [CategoryKeys.FNO_HOME]: '/futures-and-options',
  [CategoryKeys.FUTURES_DETAIL_PAGE]: '/futures/[slug]',
  [CategoryKeys.OPTIONS_DETAIL_PAGE]: '/options/[slug]',

  // calculators
  [CategoryKeys.CALCULATORS_HOME]: '/calculators',
  [CategoryKeys.CALCULATORS_PAGE]: '/calculators/[slug]',

  // NOTE: direct calculator paths --> temperory usage for now need to be unified in one path
  [CategoryKeys.CALCULATORS_BROKERAGE]: '/calculators/brokerage-calculator',
  [CategoryKeys.CALCULATORS_HRA]: '/calculators/hra-calculator',
  [CategoryKeys.CALCULATORS_NPS]: '/calculators/nps-calculator',
  [CategoryKeys.CALCULATORS_SALARY]: '/calculators/salary-calculator',
  [CategoryKeys.CALCULATORS_TERM_INSURANCE]:
    '/calculators/term-insurance-calculator',
  [CategoryKeys.CALCULATORS_INCOME_TAX]: '/calculators/income-tax-calculator',
  [CategoryKeys.CALCULATORS_DIRECT_REGULAR_MF]:
    '/calculators/direct-regular-mutual-funds',

  // IND Learn
  [CategoryKeys.LEARN_HOME]: '/learn',
  [CategoryKeys.LEARN_COURSE]: '/learn/[course_slug]',
  [CategoryKeys.LEARN_CHAPTER]: '/learn/[course_slug]/[chapter_slug]',

  // Features
  [CategoryKeys.FEATURES_HOME]: '/features',
  [CategoryKeys.FEATURES_DETAIL]: '/features/[slug]',

  // IPO
  [CategoryKeys.IPO_HOME]: '/ipo',
  [CategoryKeys.IPO_DETAIL]: '/ipo/[slug]',

  // US STOCKS
  [CategoryKeys.US_STOCKS_HOME]: '/us-stocks',
  [CategoryKeys.US_STOCKS_DETAIL]: '/us-stocks/[pn1]/[pn2]',
  [CategoryKeys.US_STOCKS_CATEGORY]: '/us-stocks/catalogue/[category]',
  [CategoryKeys.US_STOCKS_DIVIDEND]: '/us-stocks/dividends/[slug]',
  [CategoryKeys.US_STOCKS_TECHNICAL]: '/us-stocks/technical-analysis/[slug]',
}

export const strapiCategoryConstant = {
  [CategoryKeys.HOME]: 'home',
  // stocks
  [CategoryKeys.STOCKS_HOME]: 'stocks-home',
  [CategoryKeys.STOCKS_DIVIDEND]: 'stocks-dividend',
  [CategoryKeys.STOCKS_DETAIL]: 'stocks-detail',
  [CategoryKeys.STOCKS_CATEGORY]: 'stocks-category',
  [CategoryKeys.STOCKS_RESULTS]: 'stocks-results',

  // mutual funds
  [CategoryKeys.MF_HOME]: 'mutual-fund-home',
  [CategoryKeys.MF_FUND_DETAIL]: 'mutual-fund-detail',
  [CategoryKeys.MF_CATEGORY]: 'mutual-fund-category',
  [CategoryKeys.MF_AMC]: 'mutual-fund-amc',

  // articles
  [CategoryKeys.ARTICLES_HOME]: 'articles-home',
  [CategoryKeys.ARTICLES_DETAIL]: 'articles-detail',
  [CategoryKeys.ARTICLES_CATEGORY_DETAIL]: 'articles-category-detail',

  // indices
  [CategoryKeys.INDICES_HOME]: 'indices-home',
  [CategoryKeys.INDICES_DETAIL]: 'indices-detail',

  //fno
  [CategoryKeys.FNO_HOME]: 'fno-home',
  [CategoryKeys.FUTURES_DETAIL_PAGE]: 'futures-detail',
  [CategoryKeys.OPTIONS_DETAIL_PAGE]: 'options-detail',

  // calculators
  [CategoryKeys.CALCULATORS_HOME]: 'calculators-home',
  [CategoryKeys.CALCULATORS_PAGE]: 'calculators-page',

  [CategoryKeys.CALCULATORS_BROKERAGE]: 'calculators-brokerage',
  [CategoryKeys.CALCULATORS_HRA]: 'calculators-hra',
  [CategoryKeys.CALCULATORS_NPS]: 'calculators-nps',
  [CategoryKeys.CALCULATORS_SALARY]: 'calculators-salary',
  [CategoryKeys.CALCULATORS_TERM_INSURANCE]: 'calculators-term-insurance',
  [CategoryKeys.CALCULATORS_INCOME_TAX]: 'calculators-income-tax',
  [CategoryKeys.CALCULATORS_DIRECT_REGULAR_MF]: 'calculators-direct-regular-mf',

  // IND Learn
  [CategoryKeys.LEARN_HOME]: 'learn-home',
  [CategoryKeys.LEARN_COURSE]: 'learn-course',
  [CategoryKeys.LEARN_CHAPTER]: 'learn-chapter',

  // Features
  [CategoryKeys.FEATURES_HOME]: 'features-home',
  [CategoryKeys.FEATURES_DETAIL]: 'features-detail',

  // IPO
  [CategoryKeys.IPO_HOME]: 'ipo-home',
  [CategoryKeys.IPO_DETAIL]: 'ipo-detail',

  // US STOCKS
  [CategoryKeys.US_STOCKS_HOME]: 'us-stocks-home',
  [CategoryKeys.US_STOCKS_DETAIL]: 'us-stocks-detail',
  [CategoryKeys.US_STOCKS_CATEGORY]: 'us-stocks-category',
  [CategoryKeys.US_STOCKS_DIVIDEND]: 'us-stocks-dividend',
  [CategoryKeys.US_STOCKS_TECHNICAL]: 'us-stocks-technical',
}

export const getCategoryFromPath = (path: string): string | null => {
  const category = Object.entries(categoryRoutes).find(
    ([, value]) => path === value,
  )
  return category ? strapiCategoryConstant[category[0]] : null
}

export const getPageSourceFromPath = (path: string): string => {
  const category = getCategoryFromPath(path)
  let pageSource = ''
  if (category) {
    pageSource = category.replaceAll('-', '_')
  }
  return pageSource
}
